import { requisitarJson } from '../../../shared/api/http';
import type { CredenciaisLogin, SessaoAdmin, UsuarioAdmin } from '../model/types';

interface RespostaAutenticacao {
    usuario: UsuarioAdmin;
    csrf_token: string;
    expira_em?: string;
}

function paraSessao(resposta: RespostaAutenticacao): SessaoAdmin {
    return { usuario: resposta.usuario, csrfToken: resposta.csrf_token, expiraEm: resposta.expira_em };
}

export async function entrar(credenciais: CredenciaisLogin): Promise<SessaoAdmin> {
    return paraSessao(await requisitarJson<RespostaAutenticacao>('/api/v1/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Admin-Client': 'web' },
        body: JSON.stringify(credenciais),
    }));
}

export async function consultarSessao(): Promise<SessaoAdmin> {
    return paraSessao(await requisitarJson<RespostaAutenticacao>('/api/v1/auth/eu'));
}

export async function sair(csrfToken: string): Promise<void> {
    await requisitarJson<void>('/api/v1/auth/logout', { method: 'POST', csrfToken });
}
